import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const baseClasses =
	"flex flex-col gap-grid-component-spacing-md font-body text-sm leading-[1.5] text-text-dark-text-1 [&_a]:underline [&_ol]:list-decimal [&_ol]:pl-4 [&_ul]:list-disc [&_ul]:pl-4 [&_p]:leading-[1.5]";

/**
 * Consistent rich text wrapper for body copy inside bloks.
 * Wraps children in a flex column with paragraph spacing and styles inline
 * anchors, ordered and unordered lists.
 */
export const Prose = ({ children, className }: { children: ReactNode; className?: string }) => {
	return <div className={twMerge(baseClasses, className)}>{children}</div>;
};
